import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

import WaterIconSvg from "../../../assets/images/water_icon.svg";
import GasIconSvg from "../../../assets/images/gas_icon.svg";
import HeatIconSvg from "../../../assets/images/heat_icon.svg";
import ElevatorIconSvg from "../../../assets/images/elevator_icon.svg";
import BuildingIconSvg from "../../../assets/images/building_icon.svg";
import HouseIconSvg from "../../../assets/images/house_icon.svg";
import MiscellaneousIconSvg from "../../../assets/images/miscellaneous_icon.svg";
import FeedInSystemIconSvg from "../../../assets/images/feed_in_system.svg";
import EditIconSvg from "../../../assets/images/edit_icon.svg";
import DownloadIconSvg from "../../../assets/images/download_icon.svg";
import MenuIconSvg from "../../../assets/images/chevron-down_icon.svg";
import PowerIconSvg from "../../../assets/images/power_icon.svg";
import NewConnectionIconSvg from "../../../assets/images/new_connection_icon.svg";
import ModificationIconSvg from "../../../assets/images/modification_icon.svg";
import RemovalIconSvg from "../../../assets/images/removal_icon.svg";
import ChargerIconSvg from "../../../assets/images/charger_icon.svg";
import IncreaseIconSvg from "../../../assets/images/increase_icon.svg";
import JunctionBoxRelocationDistanceIconSvg from "../../../assets/images/junction_box_relocation_distance_icon.svg";
import RelocationJunctionBoxIconSvg from "../../../assets/images/relocation_junction_box_icon.svg";
import RecolcationJunctionBoxAndCableIconSvg from "../../../assets/images/relocation_junction_box_and_cable_icon.svg";
import ModificationPowerCableIconSvg from "../../../assets/images/modification_power_cable_icon.svg";
import NextIconSvg from "../../../assets/images/next_icon.svg";
import PreviousIconSvg from "../../../assets/images/previous_icon.svg";
import CalendarIconSvg from "../../../assets/images/date.svg";
import ViewEditSvg from "../../../assets/images/view_edit_chevron-down_icon.svg";
import GoIconSvg from "../../../assets/images/go_icon.svg";
import HouseFuseIconSvg from "../../../assets/images/house_fuse_icon.svg";
import PlugIconSvg from "../../../assets/images/plug_icon.svg";
import ChargingStationIconSvg from "../../../assets/images/charging_station_icon.svg";
import DeleteIconSvg from "../../../assets/images/delete_icon.svg";
import CalculatorIconSvg from "../../../assets/images/calc_icon.svg";
import GeneralPowerSvg from "../../../assets/images/general_power.svg"
import SaunaSvg from "../../../assets/images/sauna.svg"
import CloseSvg from "../../../assets/images/close_icon.svg"
import ElectricDeviceIconSvg from "../../../assets/images/electric_device.svg"
import ChargingDeviceIconSvg from "../../../assets/images/charging_device.svg"
import HeatPumpIconSvg from "../../../assets/images/heat_pump.svg"
import RoomCoolingIconSvg from "../../../assets/images/room_cooling_device.svg"

export const useIconStyles = makeStyles(() => ({
    size64: {
        width: 64,
        height: 64,
        objectFit: "contain",
    },
    size56: {
        width: 56,
        height: 56,
        objectFit: "contain",
    },
    size32: {
        width: 32,
        height: 32,
        objectFit: "contain",
    },
    size30: {
        width: 30,
        height: 30,
        objectFit: "contain",
    },
    size24: {
        width: 24,
        height: 24,
        objectFit: "contain",
    },
    size16: {
        width: 16,
        height: 16,
        objectFit: "contain",
    },
    size118x90: {
        width: 118,
        height: 90,
        objectFit: "contain",
    },
    size150x100: {
        width: 150,
        height: 100,
        objectFit: "contain",
    },
}));

interface IconProps {
    size?: keyof ReturnType<typeof useIconStyles>;
}

export const GoIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={GoIconSvg} />;
};

export const WaterIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={WaterIconSvg} />;
};

export const HeatIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={HeatIconSvg} />;
};

export const ElevatorIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={ElevatorIconSvg} />;
};

export const BuildingIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={BuildingIconSvg} />;
};

export const HouseIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={HouseIconSvg} />;
};

export const MiscellaneousIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={MiscellaneousIconSvg} />;
};

export const HouseFuseIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={HouseFuseIconSvg} />;
};

export const PlugIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={PlugIconSvg} />;
};

export const FeedInSystemIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={FeedInSystemIconSvg} />;
};

export const EditIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={EditIconSvg} />;
};

export const DownloadIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size30} src={DownloadIconSvg} />;
};

export const MenuIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size24} src={MenuIconSvg} />;
};

export const ViewEditIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size16} src={ViewEditSvg} />;
};

export const GasIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size64} src={GasIconSvg} />;
};

export const PowerIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={PowerIconSvg} />;
};

export const ElectricDeviceIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={ElectricDeviceIconSvg} />;
};

export const ChargingDeviceIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={ChargingDeviceIconSvg} />;
};

export const HeatPumpIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={HeatPumpIconSvg} />;
};

export const RoomCoolingIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={RoomCoolingIconSvg} />;
};

export const NewConnectionIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={NewConnectionIconSvg} />;
};
export const ModificationIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={ModificationIconSvg} />;
};
export const RemovalIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={RemovalIconSvg} />;
};
export const ChargerIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={ChargerIconSvg} />;
};
export const IncreaseIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={IncreaseIconSvg} />;
};
export const ChargingStationIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={ChargingStationIconSvg} />;
};

export const DeleteIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={DeleteIconSvg} />;
};

export const CalculatorIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={CalculatorIconSvg} />;
};

export const JunctionBoxRelocationDistanceIcon: FC = () => {
    const classes = useIconStyles();
    return (
        <img
            alt=""
            className={classes.size118x90}
            style={{ marginLeft: "auto" }}
            src={JunctionBoxRelocationDistanceIconSvg}
        />
    );
};

export const RelocationJunctionBoxIcon: FC = () => {
    const classes = useIconStyles();
    return (
        <img
            alt=""
            className={classes.size150x100}
            style={{ marginLeft: "auto" }}
            src={RelocationJunctionBoxIconSvg}
        />
    );
};

export const RelocationJunctionBoxAndCableIcon: FC = () => {
    const classes = useIconStyles();
    return (
        <img
            alt=""
            className={classes.size150x100}
            style={{ marginLeft: "auto" }}
            src={RecolcationJunctionBoxAndCableIconSvg}
        />
    );
};

export const ModificationPowerCableIcon: FC = () => {
    const classes = useIconStyles();
    return (
        <img
            alt=""
            className={classes.size150x100}
            style={{ marginLeft: "auto" }}
            src={ModificationPowerCableIconSvg}
        />
    );
};

export const NextIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size16} src={NextIconSvg} />;
};
export const PreviousIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size16} src={PreviousIconSvg} />;
};
export const CalendarIcon: FC = () => {
    const classes = useIconStyles();
    return <img alt="" className={classes.size24} src={CalendarIconSvg} />;
};
export const GeneralPowerIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={GeneralPowerSvg} />;
};
export const SaunaIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={SaunaSvg} />;
};

export const CloseIcon: FC<IconProps> = (props: IconProps) => {
    const classes = useIconStyles();
    return <img alt="" className={classes[props.size || "size64"]} src={CloseSvg} />;
};
